"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = void 0;
const validation_1 = __importDefault(require("../../../validation"));
const rules_1 = __importDefault(require("../../../validation/rules"));
const postBodyRules = {
    isLoggedInAndVerified: rules_1.default.boolean().required(),
    firstName: rules_1.default.string().sanitizeForHTMLJS().label('First Name').when('isLoggedInAndVerified', {
        is: false,
        then: schema => schema.required().max(50, 'You used too many characters. Please reduce the number of charactes to fit the limit of 50 characters.'),
    }),
    lastName: rules_1.default.string().sanitizeForHTMLJS().label('Last Name').when('isLoggedInAndVerified', {
        is: false,
        then: schema => schema.required().max(50, 'You used too many characters. Please reduce the number of charactes to fit the limit of 50 characters.'),
    }),
    email: rules_1.default.string().sanitizeForHTMLJS().email().label('Email')
        .when('isLoggedInAndVerified', {
        is: false,
        then: schema => schema.required(),
    }),
    topic: rules_1.default.string().sanitizeForHTMLJS().required().max(50, 'You used too many characters. Please reduce the number of charactes to fit the limit of 50 characters.')
        .label('Topic'),
    inquiry: rules_1.default.string().sanitizeForHTMLJS().required().max(500, 'You used too many characters. Please reduce the number of charactes to fit the limit of 500 characters.')
        .label('Inquiry'),
};
const postBody = {
    rules: postBodyRules,
    schema: validation_1.default.schema(postBodyRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.post = { body: postBody };
